class MegaMenu {
    constructor() {
        this.navItems = document.querySelectorAll('.nav-link');
        this.megaMenuContainer = document.querySelector('.mega-menu-container');
        this.initializeMenu();
    }

    initializeMenu() {
        this.navItems.forEach(item => {
            const placeholder = item.querySelector('.mega-menu-placeholder');

            if (placeholder) {
                const menuHandle = placeholder.dataset.menu;
                const megaMenu = document.getElementById('mega-menu-' + menuHandle);


                if (megaMenu) {
                    this.addEventListeners(item, megaMenu);
                }
            }
        });
    }

    addEventListeners(item, megaMenu) {
        item.addEventListener('mouseenter', () => {
            this.showMenu(megaMenu);
        });

        item.addEventListener('mouseleave', () => {
            setTimeout(() => {
                if (!megaMenu.matches(':hover') && !item.matches(':hover')) {
                    this.hideMenu(megaMenu);
                }
            }, 100);
        });

        megaMenu.addEventListener('mouseleave', () => {
            setTimeout(() => {
                if (!megaMenu.matches(':hover') && !item.matches(':hover')) {
                    this.hideMenu(megaMenu);
                }
            }, 100);
        });

        megaMenu.addEventListener('mouseenter', () => {
            this.showMenu(megaMenu);
        });
    }

    showMenu(megaMenu) {
        megaMenu.classList.add('show');
        document.body.style.overflow = 'hidden';
    }

    hideMenu(megaMenu) {
        megaMenu.classList.remove('show');
        document.body.style.overflow = 'auto';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new MegaMenu();
});
